import { Text } from "@shopify/polaris"
import { observer } from "mobx-react"
import { focusInstance } from "polaris-enhance"
import { useMemo } from "react"
import { useHistory } from "react-router-dom"

import stores from "@/stores"
import { hasChosenPlan } from "@/utils/plan"

const getEndsInLabel = (restTrialDays: number, restSeconds: number) => {
  if (restTrialDays > 1) {
    return {
      value: restTrialDays,
      unit: "days",
    }
  }
  const hours = Math.max(1, Math.ceil(restSeconds / 3600))
  return {
    value: hours,
    unit: hours === 1 ? "hour" : "hours",
  }
}

export function V6TrialEndBanner() {
  const history = useHistory()
  const { PlanStore } = stores
  const userPkg = PlanStore.config?.user_pkg
  const restTrialDays = userPkg?.rest_trial_days ?? 0
  const restSeconds = userPkg?.rest_seconds ?? 0
  const hasChosenPlanFlag = hasChosenPlan()
  const isTrialActive = restTrialDays > 0 || restSeconds > 0
  const shouldShowBanner = isTrialActive && !hasChosenPlanFlag

  const maxDiscountPercent = useMemo(() => {
    let maxRate = 0
    PlanStore.completedPackageList?.forEach((plan) => {
      Object.values(plan.priceInfo ?? {}).forEach((pricingList) => {
        pricingList?.forEach((item) => {
          const rate = Number(item.discount_rate ?? 0)
          if (rate > maxRate) maxRate = rate
        })
      })
    })
    return maxRate > 0 ? Math.round(maxRate * 100) : 50
  }, [PlanStore.completedPackageList])

  if (!shouldShowBanner) return null

  const { value, unit } = getEndsInLabel(restTrialDays, restSeconds)

  return (
    <div className="flex flex-wrap items-center justify-center gap-4 bg-[#1a1a1a] px-4 py-[10px]">
      <Text variant="bodyMd" as="span" fontWeight="medium">
        <span className="whitespace-nowrap text-white">
          {`[ Ends in ${value} ${unit} ]`}
        </span>
      </Text>
      <Text variant="bodyMd" as="span" fontWeight="medium">
        <span className="whitespace-nowrap text-white">
          {`Don't let your trial expire! Choose a plan today and get up to ${maxDiscountPercent}% off`}
        </span>
      </Text>
      <button
        type="button"
        className="cursor-pointer border-0 bg-transparent p-0 text-sm font-semibold text-white underline"
        onClick={() => {
          history.push("/billing")
          focusInstance.add("plan-item-Professional")
        }}
      >
        Try Now
      </button>
    </div>
  )
}

export default observer(V6TrialEndBanner)
